import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useReducer } from 'react';
import { getWordCount, sha256Hash } from './utils';
var defaultAnalyticsContextState = {
  queryVersion: 0,
  isLoading: false
};
var analyticsContextReducer = function analyticsContextReducer(state, action) {
  switch (action.type) {
    case 'queryVersion':
      return _objectSpread(_objectSpread({}, state), {}, {
        queryVersion: action.value
      });
    case 'isLoading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.value
      });
    case 'reset':
      return defaultAnalyticsContextState;
    default:
      throw new Error();
  }
};
export var useAnalyticsContext = function useAnalyticsContext(query) {
  var _useReducer = useReducer(analyticsContextReducer, defaultAnalyticsContextState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    queryVersion = _useReducer2$.queryVersion,
    isLoading = _useReducer2$.isLoading,
    setAdditionalAnalyticsContext = _useReducer2[1];
  var addAnalyticContext = useCallback(function () {
    return {
      wordCount: getWordCount(query),
      queryLength: query.length,
      queryHash: sha256Hash(query),
      queryHashSHA256: sha256Hash(query),
      queryVersion: queryVersion
    };
  }, [query, queryVersion]);
  var nonPrivacySafeContext = useCallback(function () {
    return {
      query: query
    };
  }, [query]);
  return {
    isLoading: isLoading,
    setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
    addAnalyticContext: addAnalyticContext,
    nonPrivacySafeContext: nonPrivacySafeContext,
    queryVersion: queryVersion
  };
};